import useResource from "./useResource"
import { pluralize } from "web/services/inflector"
export default function useTopicRecord({
  id,
  subjectType,
  subjectId,
  topicId,
}) {
  const key = subjectId
    ? `/${pluralize(subjectType)}/${subjectId}/topics/${topicId}/records/${id}`
    : `/topics/records/${id}`

  const [topicRecord, { update }] = useResource({
    key,
    mutateFromUpdate: true,
    params: { topic_id: topicId },
  })

  async function updateTopicRecord(data, localData) {
    return update({ ...data, topic_id: topicId }, localData)
  }

  topicRecord.update = updateTopicRecord

  return topicRecord
}
